import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner7 from '../assets/banner7.jpg';


export default function PageTitle({title}) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "capitalize",
											}}
										>
											{title}
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}